var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcome"},[_c('shifts-wrapper'),_c('drawer',{attrs:{"title":"Create/Edit"}},[_c('shift-create')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }